import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import selectShape from 'propTypes/selectShape';

const CurrencySelector = ({
  value,
  onChange,
  isSearchable = false,
  options,
  ...rest
}) => (
  <Select
    isSearchable={isSearchable}
    value={value}
    style={{ width: '50%', display: 'inline-block' }}
    onChange={onChange}
    options={options}
    {...rest}
  />
);

CurrencySelector.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, selectShape]),
  onChange: PropTypes.func,
  isSearchable: PropTypes.bool,
  options: PropTypes.arrayOf(selectShape),
};

CurrencySelector.defaultProps = {
  options: [
    { label: 'USD ($)', value: '$' },
    { label: 'GBP (£)', value: '£' },
    // { label: 'EUR (€)', value: '€' },
  ],
};

export default CurrencySelector;
